var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-24"},[_c('div',{staticClass:"bg-white border-gray-3",staticStyle:{"height":"calc(100vh - 89px)","border":"1px solid"}})])}]

export { render, staticRenderFns }